import { configureStore } from '@reduxjs/toolkit'
import authReducer from '../features/auth/authSlice'
import practitionerProfileReducer from '../features/practitionerProfiles/practitionerProfileSlice'
import emailCollectionReducer from "../features/emailCollection/emailCollectionSlice"
import userReducer from "../features/user/userSlice"
import individualOptionReducer from "../features/individualOptions/individualOptionsSlice"
import employerContactReducer from "../features/employerContact/employerContactSlice"

export const store = configureStore({
  reducer: {
    auth: authReducer,
    practitionerProfiles: practitionerProfileReducer,
    emailCollection: emailCollectionReducer,
    user: userReducer,
    individualOptions: individualOptionReducer,
    employerContacts: employerContactReducer
  },
});
